import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { NavigationModule } from './components/navigation/navigation.module';
import { SeoData, SeoService } from './services/seo/seo.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavigationModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnDestroy {
  title = 'Manava Immobilier';

  private readonly routerSubscription: Subscription;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly seo: SeoService
  ) {
    this.routerSubscription = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }
      const seoData = route.snapshot.data['seo'] as SeoData | undefined;
      if (!seoData) {
        return;
      }
      const isPropertyDetail = route.snapshot.routeConfig?.path === ':name';
      const path = isPropertyDetail ? this.router.url.split('?')[0] : seoData.path;
      this.seo.updatePage({ ...seoData, path });
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }
}
